import { useEffect } from 'react';
import { IAppReducer } from 'models/reducer.interface';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

interface IAuthGuardPros {
  children: JSX.Element;
  privateRoute: boolean;
}

/**
 * Cuando Soda impersona con `lockToEditPlan` (ver AutoImpersonate), el agente queda
 * confinado a `/edit-plan`: cualquier otra ruta (incl. botón atrás) lo devuelve a
 * `returnUrl` de inmediato. No afecta otras impersonations (ej. add-subscription),
 * que siguen navegando libremente por Meraki como hoy.
 */
export const AuthGuard = ({ children, privateRoute }: IAuthGuardPros) => {
  const user = useSelector((state: IAppReducer) => state.authReducer);
  const location = useLocation();

  const { returnUrl, lockToEditPlan } = user.agentAuthData ?? {};
  const shouldBounceToSoda = Boolean(
    privateRoute && lockToEditPlan && returnUrl && !location.pathname.startsWith('/edit-plan')
  );

  useEffect(() => {
    if (!shouldBounceToSoda || !returnUrl) return;
    globalThis.location.href = returnUrl;
  }, [shouldBounceToSoda, returnUrl]);

  if (privateRoute) {
    if (!user.uid) return <Navigate to="/login" />;
    if (shouldBounceToSoda) return null;
    return children;
  } else {
    return user.uid ? <Navigate to="/settings" /> : children;
  }
};
